import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/appConfig';

export default function SuperAdminDashboard({ onNavigate, onAuthError }) {
    const [dashboard, setDashboard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const token = localStorage.getItem('superadmin_token');
    const authHeaders = { headers: { 'token': token, 'Content-Type': 'application/json' } };

    useEffect(() => {
        cargarDashboard();
    }, []);

    const cargarDashboard = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.get(config.api_url + '/api/bimba/dashboard', authHeaders);
            if (res.data && res.data.status === "success") {
                setDashboard(res.data.data);
            } else {
                setError(res.data.message || "Error al cargar dashboard");
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            setError(
                !err.response
                    ? "No se pudo conectar con el servidor. Intenta de nuevo."
                    : "Error de conexión con el servidor"
            );
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid #e5e7eb',
                        borderTopColor: '#667eea',
                        borderRadius: '50%',
                        animation: 'spin 0.6s linear infinite',
                        margin: '0 auto 16px'
                    }} />
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>Cargando dashboard...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                margin: '24px',
                padding: '20px',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                color: '#dc2626',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                <span style={{ flex: 1 }}>{error}</span>
                <button onClick={cargarDashboard} style={{
                    padding: '8px 16px',
                    background: '#dc2626',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 500
                }}>
                    Reintentar
                </button>
            </div>
        );
    }

    const d = dashboard || {};

    const cards = [
        {
            titulo: 'Total Negocios',
            valor: d.total_negocios || 0,
            icono: 'building',
            color: '#667eea',
            bgColor: '#eef0ff',
            trend: '+12% este mes'
        },
        {
            titulo: 'Al Día',
            valor: d.al_dia || 0,
            icono: 'check-circle',
            color: '#10b981',
            bgColor: '#e6faf5',
            trend: 'Sin problemas'
        },
        {
            titulo: 'Pendientes',
            valor: d.pendiente || 0,
            icono: 'alert-triangle',
            color: '#f59e0b',
            bgColor: '#fff8e6',
            trend: 'Requieren atención'
        },
        {
            titulo: 'Bloqueados',
            valor: d.bloqueada || 0,
            icono: 'x-octagon',
            color: '#ef4444',
            bgColor: '#ffe6e6',
            trend: 'Acción requerida'
        },
        {
            titulo: 'Próximos a Vencer',
            valor: d.proximos_vencer || 0,
            icono: 'clock',
            color: '#f97316',
            bgColor: '#fff4e6',
            trend: 'En 7 días'
        },
        {
            titulo: 'Vencidos',
            valor: d.vencidos || 0,
            icono: 'calendar-x',
            color: '#dc2626',
            bgColor: '#ffe6e6',
            trend: 'Período de gracia'
        }
    ];

    const iconMap = {
        'building': 'M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11m16-11v11M8 14v.01m4-.01v.01m4-.01v.01M8 18v.01m4-.01v.01m4-.01v.01',
        'check-circle': 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4L12 14.01l-3-3',
        'alert-triangle': 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4h.01',
        'x-octagon': 'M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM15 9l-6 6m0-6l6 6',
        'clock': 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z',
        'calendar-x': 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V8h14v12zM9 10l6 6m0-6l-6 6'
    };

    return (
        <div style={{
            padding: '32px',
            maxWidth: '1200px',
            margin: '0 auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* HEADER */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '32px'
            }}>
                <div>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        margin: '0 0 8px',
                        letterSpacing: '-0.5px'
                    }}>Dashboard</h1>
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
                        Resumen global del sistema Komity POS
                    </p>
                </div>
                <button onClick={cargarDashboard} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '10px 20px',
                    background: '#fff',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '10px',
                    color: '#374151',
                    fontSize: '13px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                    </svg>
                    Actualizar
                </button>
            </div>

            {/* MÉTRICAS */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '20px',
                marginBottom: '32px'
            }}>
                {cards.map((card, index) => (
                    <div key={index} style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        padding: '24px',
                        transition: 'all 0.2s',
                        cursor: 'default'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                background: card.bgColor,
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={card.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d={iconMap[card.icono]}/>
                                </svg>
                            </div>
                            <span style={{
                                fontSize: '11px',
                                color: '#9ca3af',
                                fontWeight: 500,
                                padding: '2px 8px',
                                background: '#f9fafb',
                                borderRadius: '6px'
                            }}>{card.trend}</span>
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <p style={{
                                fontSize: '13px',
                                color: '#6b7280',
                                margin: '0 0 4px',
                                fontWeight: 500
                            }}>{card.titulo}</p>
                            <h2 style={{
                                fontSize: '32px',
                                fontWeight: '700',
                                color: '#1a1a2e',
                                margin: 0,
                                letterSpacing: '-1px'
                            }}>{card.valor}</h2>
                        </div>
                    </div>
                ))}
            </div>

            {/* ACCIONES RÁPIDAS */}
            <div style={{
                background: '#fff',
                borderRadius: '16px',
                border: '1px solid #f3f4f6',
                padding: '28px'
            }}>
                <div style={{ marginBottom: '20px' }}>
                    <h3 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#1a1a2e',
                        margin: '0 0 4px'
                    }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginRight: '8px' }}>
                            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                        </svg>
                        Acciones Rápidas
                    </h3>
                    <p style={{ color: '#6b7280', fontSize: '13px', margin: 0 }}>
                        Atajos para las tareas más comunes
                    </p>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                    {[
                        { label: 'Ver Todos los Negocios', icon: 'building', action: 'negocios', color: '#1a1a2e', bg: '#f3f4f6' },
                        { label: 'Crear Nuevo Negocio', icon: 'plus-circle', action: 'nuevo', color: '#10b981', bg: '#e6faf5' },
                        { label: 'Ver Pendientes', icon: 'alert-triangle', action: 'negocios', param: 'PENDIENTE', color: '#f59e0b', bg: '#fff8e6' },
                        { label: 'Ver Bloqueados', icon: 'x-octagon', action: 'negocios', param: 'BLOQUEADA', color: '#ef4444', bg: '#ffe6e6' },
                    ].map((btn, i) => (
                        <button key={i} onClick={() => onNavigate(btn.action, btn.param)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '12px 20px',
                                background: btn.bg,
                                border: 'none',
                                borderRadius: '10px',
                                color: btn.color,
                                fontSize: '13px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                            }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d={iconMap[btn.icon] || 'M12 5v14m-7-7h14'}/>
                            </svg>
                            {btn.label}
                        </button>
                    ))}
                </div>
            </div>

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                div[style*="border-radius: 16px"]:hover {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
                }
            `}</style>
        </div>
    );
}
